import React from 'react';
import './Banner.css';
import bannerImage from '../home.jpg';

const Banner = () => {
    return (
        <div className="banner-section">
            <div className="banner-content">
                <h1>Welcome to D-Astars Pharmaceutical</h1>
                <p>Delivering Quality Healthcare Solutions with Innovation and Precision</p>
                <div className="banner-features">
                    <div className="feature">
                        <i className="fas fa-medal"></i>
                        <span>WHO-GMP Certified</span>
                    </div>
                    <div className="feature">
                        <i className="fas fa-globe"></i>
                        <span>Global Presence</span>
                    </div>
                    <div className="feature">
                        <i className="fas fa-microscope"></i>
                        <span>Advanced R&D</span>
                    </div>
                </div>
                <div className="banner-cta">
                    <a href="/products" className="primary-button">Explore Products</a>
                    <a href="/contact" className="secondary-button">Contact Us</a>
                </div>
            </div>
            <div className="banner-overlay"></div>
            <div className="banner-background" style={{ backgroundImage: `url(${bannerImage})` }}></div>
        </div>
    );
};

export default Banner;
